export default {"src":"/_next/static/media/appStore.ab11115d.svg","height":40,"width":123,"blurWidth":0,"blurHeight":0};